import Api from '@/services/Index';

const getUserGuide = async (config) => {
    config.responseType= 'arraybuffer';
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('user-guide', config);
}

const createFileToken = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/parameter/items/file-token', data);
}

export default {
    getUserGuide,
    createFileToken
}
